import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './LegalIndexPage.css';

export default function LegalIndexPage() {
  const { t, lang } = useLanguage();

  const DOCS = [
    { title: t('legal.docs.termsTitle'),          path: '/terms',           description: t('legal.docs.termsDesc') },
    { title: t('legal.docs.privacyTitle'),        path: '/privacy',         description: t('legal.docs.privacyDesc') },
    { title: t('legal.docs.cookiesTitle'),        path: '/cookies',         description: t('legal.docs.cookiesDesc') },
    { title: t('legal.docs.disclaimerTitle'),     path: '/disclaimer',      description: t('legal.docs.disclaimerDesc') },
    { title: t('legal.docs.acceptableUseTitle'),  path: '/acceptable-use',  description: t('legal.docs.acceptableUseDesc') },
    { title: t('legal.docs.billingTitle'),        path: '/billing',         description: t('legal.docs.billingDesc') },
  ];

  useEffect(() => {
    document.title = t('legal.indexMetaTitle');
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    const prev = meta.getAttribute('content');
    meta.setAttribute('content', t('legal.indexMetaDesc'));
    return () => {
      if (prev != null) meta.setAttribute('content', prev);
    };
  }, [t]);

  return (
    <main className="legal-index" lang={lang}>
      <div className="legal-index__container">
        <header className="legal-index__header">
          <p className="legal-index__crumb">{t('legal.indexCrumb')}</p>
          <h1 className="legal-index__title">{t('legal.indexTitle')}</h1>
          <p className="legal-index__subtitle">
            {t('legal.indexSubtitle')}
          </p>
        </header>

        <ol className="legal-index__list">
          {DOCS.map((doc) => (
            <li key={doc.path} className="legal-index__item">
              <Link to={doc.path} className="legal-index__card">
                <h2 className="legal-index__card-title">{doc.title}</h2>
                <p className="legal-index__card-desc">{doc.description}</p>
                <span className="legal-index__card-arrow" aria-hidden="true">
                  {t('legal.indexRead')}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </main>
  );
}
